import React from 'react'
import { BrowserRouter, Route, Switch } from 'react-router-dom'
//import Tour from 'bootstrap-tour' TODO: do something with this

/* 
This should load BEFORE the components load, or else your component's CSS rules will be overriden. 
You could have gotten around this by using very specific rules, but that is annoying. 
Still, all of your component CSS rules should only activate within that component to prevent interference between components.
*/
import 'uswds'
import 'uswds/dist/css/uswds.min.css'
import '../style/lgy-helmet.scss'
import '../style/lgy.scss'

import LgyHeader from './LgyHeader'
import Transition from './Transition'
import LoadingUser from './LoadingUser'
import FourOhFourFallback from './FourOhFourFallback'
import GoogleAnalytics from './GoogleAnalytics'
import PartialRegistrationRedirect from './PartialRegistrationRedirect'
import GuarantyCalculatorGear from 'app/gears/guarantycalculator/components/GuarantyCalculatorGear'
import VisBrowser from 'app/gears/visbrowser/components/VisBrowser'
import Home from 'app/gears/home/components/Home'
import Alert from 'app/gears/alert/components/Alert'
import ErrorModalContainer from 'app/gears/errorhandler/containers/ErrorModalContainer'
import AppraisalContainer from 'app/gears/appraiser/workspace/containers/AppraisalContainer'
import LgyBreadcrumbs from 'app/gears/lgybreadcrumbs/LgyBreadcrumbs'
import LandingPage from 'app/gears/landing/components/LandingPage'
import HelpCenter from 'app/gears/help/help-center/components/HelpCenter'
import LgyAnonymousLandingPage from 'app/gears/home/components/LgyAnonymousLandingPage'
import ProfileContainer from 'app/gears/profile/containers/ProfileContainer'
import LgyBigFooter from 'app/gears/home/components/LgyBigFooter'
import SessionTimeoutContainer from '../containers/SessionTimeoutContainer'
import AdminGear from 'app/gears/admin/components/AdminGear'
import AnnouncementsGear from 'app/gears/announcements/containers/AnnouncementsGear'
import CondoBuilderContainer from 'app/gears/condo-builder/containers/CondoBuilderContainer'
import OversightWorkspace from 'app/gears/oversight/containers/OversightWorkspace'
import NADLApp from 'app/gears/nadl/containers/NADLApp'
import FundingFeeContainer from 'app/gears/funding-fee/containers/FundingFeeContainer'
import HelpTicketContainer from 'app/gears/help/ticket/containers/HelpTicketContainer'
import LgyChunkedFileUpload from 'app/components/util/lgy-chunked-file-upload/LgyChunkedFileUpload'

const App = ({ user, serverProperties, inIframe, trainingUrl }) =>
  <BrowserRouter>
    {/* TODO: Remove container div and migrate CSS to .app or main so that our HTML is easier to navigate*/}
    <div className='container'>
      {!inIframe && <SessionTimeoutContainer />}
      <ErrorModalContainer />
      <GoogleAnalytics serverProperties={serverProperties} location={window.location} />
      {!inIframe && <header className='lgy-helmet'>
        <Alert serverProperties={serverProperties} />
        <LgyHeader currentUser={user} serverProperties={serverProperties} trainingUrl={trainingUrl} />
      </header>}
      <main>
        <PartialRegistrationRedirect user={user} location={window.location} />
        {!inIframe && <Route path='/lgyhub/:id' component={LgyBreadcrumbs} />}
        <Switch>
          {user.exists && user.registered && <Route exact path='/lgyhub' component={Home} />}
          {user.exists && !user.registered && <Route exact path='/lgyhub' component={LandingPage} />}
          {window.location.hostname.endsWith('eauth.va.gov') && user.fetching && <Route exact path='/lgyhub' component={LoadingUser} />}
          <Route exact path='/lgyhub' component={LgyAnonymousLandingPage} />
          <Route exact path='/lgyhub/help' render={() => <HelpCenter serverProperties={serverProperties} />} />
          <Route exact path='/lgyhub/help/ticket' component={HelpTicketContainer} />
          <Route exact path='/lgyhub/vis-browser' component={VisBrowser} />
          <Route exact path='/lgyhub/chunked-upload' render={() => <LgyChunkedFileUpload inIframe={inIframe} />} />
          <Route exact path='/lgyhub/guaranty-calculator' component={GuarantyCalculatorGear} />
          <Route exact path='/lgyhub/home-builders' render={() => <CondoBuilderContainer builder />} />
          <Route exact path='/lgyhub/condo-report' render={() => <CondoBuilderContainer condo />} />
          <Route exact path='/lgyhub/transition' component={Transition} />
          <Route path='/lgyhub/appraiser' component={AppraisalContainer} />
          <Route path='/lgyhub/profile' component={ProfileContainer}  serverProperties={serverProperties}/>
          <Route path='/lgyhub/admin' component={AdminGear} />
          <Route path='/lgyhub/announcements/:id?' component={AnnouncementsGear} />
          <Route path='/lgyhub/oversight' component={OversightWorkspace} />
          <Route path='/lgyhub/NADL' render={() => <NADLApp user={user} />} />
          <Route path='/lgyhub/funding-fee' component={FundingFeeContainer} />
          <Route component={FourOhFourFallback} />
        </Switch>
      </main>
      <Route path='/lgyhub' exact component={LgyBigFooter} />
    </div>
  </BrowserRouter>
export default App
